import { Component, OnInit, Input } from '@angular/core';
import { CarrinhoItemsModel } from '../../../../models/carrinhoItems.model'
import { UsersService } from '../../../../models/usuarios.service'
import { QueryFn } from 'angularfire2/firestore';
import { Formatter } from '../../../../comum/pipes/formatter';
import { Router,ActivatedRoute} from '@angular/router'
import { EstadoItens } from '../../../../models/estadoItens.model'
import { PrinterService } from '../../services/printer.service';

export interface IPedidoHeader {
  pedido: string;
  cliente: string;
  data: string;
  qtde: string;
  total: string;
  estadoMin: string
}

@Component({
  selector: 'minhas-vendas-fornecedor',
  templateUrl: './minhas-vendas-fornecedor.component.html',
  styleUrls: ['./minhas-vendas-fornecedor.component.scss']
})
export class MinhasVendasFornecedorComponent implements OnInit {
  private pedidoModel: CarrinhoItemsModel
  colunas: string[] = ['pedido', 'cliente', 'qtde', 'total', 'estadoMin', 'detalhe']
  dataSource: IPedidoHeader[]
  estados: Array<any>
  pedidos: Array<IPedidoHeader> = []  
  pedidosItens : Array<any>
  dataAtual: Date = new Date()
  fornecedorAtual : number 
  estadosModel: EstadoItens
  constructor(
    private usersService: UsersService,
    private router: Router,
    private route : ActivatedRoute,
    private printerSvc : PrinterService
  ) {

      this.route.params.subscribe((params)=>{
      
        if(params['fornecedor']){
          this.fornecedorAtual = Number(params['fornecedor'])
        }  
        if(params['data']){
          this.dataAtual = new Date(`${params['data']} 00:00:00`)
        } 
        this.pedidoModel = new CarrinhoItemsModel(this.usersService.usuarioClass.dbConn, this.usersService)
        this.estadosModel = new EstadoItens(usersService.usuarioClass.dbConn)

        this.estadosModel.snapshot((elem) => { return elem.where('inativo', '==', false) },
          (data) => {
            if (data && (data.length > 0)) {
              this.estados = data
              this.carregarPedidos();
            }

          }, true)       
    })
  }

  private carregarPedidos() {
    this.pedidoModel.pedidoClass.snapshot(
      this.where(), 
      (data: Array<any>) => {
      if (data && (data.length > 0)) {
        this.separarPorPedido(data);
      }
    }, true);
  }

  estadoPorCodigo(estado) {
    let estados = this.estados.filter(function (item) { return (item.codigo == estado) })
    if (estados && (estados.length > 0))
      return estados[0]
  }

  ngOnInit() {
  }
  where(): QueryFn {
    return (elem) => {
      if (this.fornecedor == 0) {
        return elem.where('data', '>=', new Date(`${this.dataAtualStr}T00:00:00.000Z`))
          .where('data', '<=', new Date(`${this.dataAtualStr}T23:59:59.999Z`))
      }
      else {
        return elem.where('fornecedor', '==', this.fornecedor)
          .where('data', '>=', new Date(`${this.dataAtualStr}T00:00:00.000Z`))
          .where('data', '<=', new Date(`${this.dataAtualStr}T23:59:59.999Z`))
      }

    }
  }



  separarPorPedido(dt: Array<any>) {
    let data = dt.filter(function (elem) { return (elem.estado > 0) })
    //console.log(JSON.stringify(data))
    this.pedidosItens = data
    let porPedido = []
    for (let elem of data) {
      if (porPedido.indexOf(elem.pedido) === -1) {
        porPedido.push(elem.pedido)
      }
    }
    for (let elem of porPedido) {
      let nEstadoMin = this.estadoMinPorPedido(data, elem)
      let estado = this.estadoPorCodigo(nEstadoMin)
      this.pedidos.push({
        pedido: elem,
        cliente: data.filter(item => (item.pedido == elem))[0].entrega.nome || data.filter(item => (item.pedido == elem))[0].cliente.nome,
        data: this.dataAtual.toLocaleDateString(),
        qtde: CarrinhoItemsModel.formatQtde(this.qtdePorPedido(data, elem)),
        total: Formatter.formatMoney(this.somaPorPedido(data, elem)),
        estadoMin: estado ? estado.nome : String(nEstadoMin)
      })
    }
    this.pedidos.sort(function (a, b) { return ((a.pedido > b.pedido) ? 1 : (a.pedido < b.pedido) ? -1 : 0) })
    this.dataSource = this.pedidos
  }

  estadoMinPorPedido(data: Array<any>, pedido): string {
    let estados = []
    data.forEach(elem => {
      if (elem.pedido == pedido)
        estados.push(elem.estado)
    })
    return estados.sort()[0]
  }

  qtdePorPedido(data: Array<any>, pedido) {
    let qtde = 0
    data.forEach(elem => {
      if (elem.pedido == pedido)
        qtde += elem.qtde
    })
    return qtde
  }
 
  get fornecedor() : number
  {
    return this.fornecedorAtual || this.usersService.fornecedor
  }
  somaPorPedido(data: Array<any>, pedido) {
    let total = 0
    data.forEach(elem => {
      if (elem.pedido == pedido)
        total += elem.total || elem.valor
    })
    return total
  }
  dateChanges(event) {
    this.dataSource = []
    this.pedidos = []
    this.carregarPedidos()
  }

  goToDetail(nPedido) {
    if(this.usersService.isAdmin)
      this.router.navigate(['minhasVendas','vendasDiaria', 'detalhe', nPedido])
    else 
    this.router.navigate(['vendasDiaria', 'detalhe', nPedido])

  }

  printPedido(nPedido)
  {
    let pedido : Array<any> = this.pedidosItens.filter((elem)=> (elem.pedido == nPedido))
    if(!(pedido && pedido.length > 0))
       return
    this.printerSvc.printPedido( pedido )
  }

  get dataAtualStr() {
    return this.dataAtual.toISOString().substring(0, 10)
  }

  
  isVendasRootRoute(): boolean {
    let path_name : string = String(window.location.pathname)
    let result: boolean 

    let reg_exp = new RegExp(/\/vendasDiaria\/[\d]+\/[\d]+-[\d]+-[\d]+/)
    result = path_name.endsWith('/vendasDiaria')  || reg_exp.test(path_name)

    return result
  }

}
